<template>

  <div class="floatRightDiv">

    <div class="contacUsDiv">

      <a href="###" class="lxwmBtn flexcen"><i class="font_family icon-fuchuang-kefu"></i>{{ floatContactLine1 }}<br>{{ floatContactLine2 }}</a>

      <div class="zxzxDiv">

        <div class="bgDiv">

          <div class="li">

            <div class="lt float-brand-title">{{ $t('float.onlineConsult') }}</div>

            <div class="btnDiv">

              <router-link to="/contact/" class="flexcen lxBtn">{{ $t('float.contactBtn') }}</router-link>

            </div>

          </div>

          <div class="li">

            <div class="lt">{{ $t('float.contactPhone') }}</div>

            <div class="btnDiv">

              <a :href="'tel:' + phone" class="flexcen lxBtn">{{ phone }}</a>

            </div>

          </div>

          <div class="li">

            <div class="lt">{{ $t('float.scanQr') }}</div>

            <div class="smDiv flexbet">

              <div class="p">

                <p>{{ $t('float.scanWechat') }}</p>

                <p>{{ $t('float.inquirePurchase') }}</p>

                <p>{{ $t('float.oneOnOne') }}</p>

              </div>

              <div class="ewm" v-if="wechatQr">

                <img :src="$media(wechatQr)" alt="WeChat QR">

              </div>

            </div>

          </div>

          <div class="timeDiv">

            <p v-for="(line, idx) in serviceHoursLines" :key="idx">{{ line }}</p>

          </div>

        </div>

      </div>

    </div>

    <ul>

      <li v-if="wechatQr">

        <a href="###" class="cpxjBtn flexcen"><i class="font_family icon-fuchuang-erweima"></i><span>{{ floatWechatLine1 }}<br>{{ floatWechatLine2 }}</span></a>

        <div class="ewmDiv">

          <div class="bgDiv">

            <img :src="$media(wechatQr)" alt="WeChat"><p>{{ wechatOfficialLabel }}</p>

          </div>

        </div>

      </li>

    </ul>

    <a href="javascript:;" class="backBtn flexcen" @click.prevent="goTop"><i class="font_family icon-fuchuang-fanhuidingbu"></i><span>{{ floatTopLine1 }}<br>{{ floatTopLine2 }}</span></a>

  </div>

</template>



<script>

import { listContactInfo } from '@/utils/http'

export default {

  name: 'FloatingSidebar',

  data() {

    return {

      wechatQr: '',

      wechatQrTitle: '',

      phone: '',

      serviceHoursText: ''

    }

  },

  computed: {

    wechatOfficialLabel() {

      if (this.wechatQrTitle) return this.$cleanBrand(this.wechatQrTitle)

      return this.$t('float.wechatOfficial')

    },

    serviceHoursLines() {

      if (this.serviceHoursText) {

        return this.serviceHoursText.split('|').map(s => this.$cleanBrand(s.trim())).filter(Boolean)

      }

      return []

    },

    floatContactLine1() { return this.splitFloatLabel('float.contact', 0) },

    floatContactLine2() { return this.splitFloatLabel('float.contact', 1) },

    floatWechatLine1() { return this.splitFloatLabel('float.wechat', 0) },

    floatWechatLine2() { return this.splitFloatLabel('float.wechat', 1) },

    floatTopLine1() { return this.splitFloatLabel('float.returnTop', 0) },

    floatTopLine2() { return this.splitFloatLabel('float.returnTop', 1) }

  },

  watch: {

    '$i18n.locale'() {

      this.loadFloatConfig()

    }

  },

  created() {

    this.loadFloatConfig()

  },

  methods: {

    reloadCmsData() {

      this.loadFloatConfig()

    },

    async loadFloatConfig() {

      try {

        const res = await listContactInfo({ type: 0, status: 1, pageNum: 1, pageSize: 1 }, this.$i18n.locale)

        const row = (res.rows || [])[0]

        if (!row) return

        if (row.wechatQr) this.wechatQr = row.wechatQr

        if (row.phone) this.phone = row.phone

        if (row.serviceHours) this.serviceHoursText = row.serviceHours

        this.wechatQrTitle = row.wechatQrTitle || ''

      } catch (e) { /* fallback to static */ }

    },

    splitFloatLabel(key, index) {

      const text = this.$t(key)

      if (this.$i18n.locale === 'en') {

        const parts = { 'float.contact': ['Con', 'tact'], 'float.wechat': ['We', 'Chat'], 'float.feedback': ['Feed', 'back'], 'float.returnTop': ['Return', 'Top'] }

        return parts[key] ? parts[key][index] : text

      }

      const mid = Math.ceil(text.length / 2)

      return index === 0 ? text.slice(0, mid) : text.slice(mid)

    },

    goTop() {

      if (this.$route.path === '/' && window.$ && $.fn.fullpage && $.fn.fullpage.moveTo) {

        $.fn.fullpage.moveTo(1)

      } else {

        window.scrollTo({ top: 0, behavior: 'smooth' })

      }

    }

  }

}

</script>

